import React, { Component } from "react";
import Header from "../components/Header";
import { Twitter, Hash, Globe, Bookmark, X, Check, Flag } from "react-feather";
import moment from "moment";
import Footer from "../components/Footer";

export default class Launches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errormsg: "",
      upcomingdata: [],
      reverse: false,
    };
  }

  fetchData = () => {
    fetch("https://api.spacexdata.com/v3/launches")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({
            upcomingdata: data,
            isLoading: false,
            errormsg: "",
          });
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchData();
  }

  render() {
    const { isLoading, upcomingdata, errormsg, reverse } = this.state;

    let filteredData = upcomingdata.sort(
      reverse
        ? (a, b) => b.launch_date_unix - a.launch_date_unix
        : (a, b) => a.launch_date_unix - b.launch_date_unix
    );

    if (isLoading || errormsg) {
      return (
        <>
          <Header />
          <section class="hero is-black is-fullheight">
            <div class="hero-body">
              <div class="container has-text-centered">
                {errormsg ? (
                  <>
                    <h1 className="title is-5 has-text-white">
                      SpaceX Tracker
                    </h1>
                    <p>{errormsg}</p>
                    <br />
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="button is-dark"
                      style={{ marginBottom: "25px" }}
                    >
                      Try again
                    </button>
                    <br />
                    <a href="https://www.twitter.com/ingusjan" target="_blank">
                      <Twitter size={18} />
                    </a>
                  </>
                ) : (
                  <p style={{ opacity: "0.2" }}>Loading</p>
                )}
              </div>
            </div>
          </section>
        </>
      );
    }

    return (
      <div>
        <Header />
        <div
          className="notification is-radiusless"
          style={{
            userSelect: "none",
            width: "100%",
            margin: "0 auto",
            paddingTop: "10px",
            background: "transparent",
            borderBottom: "1px solid rgb(54, 54, 54)",
          }}
        >
          <p>
            <span style={{ opacity: "0.3" }}>
              {filteredData.length} found - Data is sorted{" "}
              {reverse ? "Latest → Oldest" : "Oldest → Latest"}{" "}
            </span>
            <a
              style={{ marginLeft: "5px" }}
              onClick={() => {
                this.setState({ reverse: !this.state.reverse });
              }}
            >
              Reverse
            </a>
          </p>
        </div>

        {filteredData.map((x) => (
          <>
            <div
              className="notification is-radiusless"
              style={{
                width: "100%",
                margin: "0 auto",
                background: "transparent",
                borderBottom: "1px solid rgb(54, 54, 54)",
              }}
              key={x.id}
            >
              {x.links.mission_patch_small && (
                <img
                  alt={x.mission_name + " Patch"}
                  style={{ float: "right", width: "100px", height: "100px" }}
                  src={x.links != undefined && x.links.mission_patch_small}
                />
              )}

              <h2 className="subtitle">{x.mission_name}</h2>
              {x.flight_number && (
                <p>
                  <Hash
                    size={16}
                    style={{
                      verticalAlign: "middle",
                      marginBottom: "3px",
                      marginRight: "5px",
                    }}
                  />
                  {x.flight_number}
                </p>
              )}

              <p
                style={{
                  color: x.launch_success
                    ? "green"
                    : x.launch_success == null
                    ? "gray"
                    : "red",
                }}
              >
                {x.launch_success ? (
                  <Check
                    size={16}
                    style={{
                      verticalAlign: "middle",
                      marginBottom: "2px",
                      marginRight: "5px",
                    }}
                  />
                ) : x.launch_success == null ? (
                  <Flag
                    size={16}
                    style={{
                      verticalAlign: "middle",
                      marginBottom: "2px",
                      marginRight: "5px",
                    }}
                  />
                ) : (
                  <X
                    size={16}
                    style={{
                      verticalAlign: "middle",
                      marginBottom: "2px",
                      marginRight: "5px",
                    }}
                  />
                )}

                {x.launch_success
                  ? "Mission Success"
                  : x.launch_success == null
                  ? "Not launched yet"
                  : "Mission Failed"}
              </p>

              <p style={{ opacity: "0.3" }}>
                {moment(x.launch_date_utc).format("DD/MM/YYYY hh:mm:ss")} -{" "}
                {moment(x.launch_date_utc).fromNow()}
              </p>
              <br />
              <p>{x.details ? x.details : "No information provided."}</p>
              <br />
            </div>
          </>
        ))}

        <Footer />
      </div>
    );
  }
}
